export default {
  "nav.events": "Іс-шаралар",
  "nav.gallery": "Галерея",
  "nav.contact": "Байланыс",

  "hero.benefit": "3 Зал • 10 DJ • 1 Толық билет",
  "hero.getTickets": "Билет алу",
  "hero.soldOut": "Сатылып бітті",

  "land.saveDate": "Күнді сақтап қой",
  "land.upcomingA": "Алдағы",
  "land.upcomingB": "іс-шаралар",
  "land.festival": "Фестиваль",
  "land.getTicketsArrow": "Билет алу →",

  "home.watchEyebrow": "Афтермуви мен шолулар",
  "home.watchA": "Takeover-ді",
  "home.watchB": "көр",
  "home.stagesEyebrow": "Бір билет, үш әлем",
  "home.stagesA": "Таныс",
  "home.stagesB": "3 Сахна",
  "stage.seoul.name": "Seoul Floor",
  "stage.seoul.desc": "SeoulVibes бірге",
  "stage.seoul.floor": "7-қабат",
  "stage.main.name": "Mainstream Floor",
  "stage.main.desc": "Классикалық DUPLEX тәжірибесі",
  "stage.main.floor": "6-қабат",
  "stage.saigon.name": "Saigon Floor",
  "stage.saigon.desc": "GANGSHII бірге",
  "stage.saigon.floor": "5-қабат",
  "home.lineupEyebrow": "Лайнап",
  "home.whoA": "Кім ойнайды",
  "home.whoB": "— және қашан?",
  "home.insideEyebrow": "Жоғарыдан",
  "home.insideA": "Duplex",
  "home.insideB": "ішінде",
  "home.ctaA": "Takeover-ге",
  "home.ctaB": "дайынсың ба?",
  "home.buyTickets": "Билет сатып алу",

  "footer.tagline": "Прагадағы ең үлкен азиялық фестиваль тәжірибесі. Үш зал, бір билет, ұмытылмас түн.",
  "footer.quickLinks": "Жылдам сілтемелер",
  "footer.faq": "Жиі қойылатын сұрақтар",
  "footer.terms": "Шарттар мен ережелер",
  "footer.privacy": "Құпиялылық саясаты",
  "footer.refund": "Қайтару саясаты",
  "footer.followUs": "Бізді қадағала",
  "footer.rights": "© 2026 ASIA TAKEOVER. Барлық құқықтар қорғалған.",
  "footer.doorStaff": "Кіреберіс қызметкері",
  "footer.admin": "Admin",

  "cookies.title": "Cookies",
  "cookies.text": "Біз сайтты жұмыс істету және тапсырысты өңдеу үшін қажетті cookies қолданамыз. Сіздің рұқсатыңызбен жарнама тиімділігін өлшеу үшін аналитикалық және маркетингтік cookies (Meta Pixel) де қолданамыз. Қосымша cookies-тен бас тартып, билетті сатып ала аласыз.",
  "cookies.necessary": "Қажетті (әрқашан қосулы)",
  "cookies.analytics": "Аналитика",
  "cookies.marketing": "Маркетинг / Meta Pixel",
  "cookies.acceptAll": "Барлығын қабылдау",
  "cookies.customize": "Реттеу",
  "cookies.save": "Сақтау",
  "cookies.reject": "Бас тарту",

  "tickets.eyebrow": "Билеттер",
  "tickets.standard": "Standard билет",
  "tickets.group": "4 адамға арналған топ",
  "tickets.vip": "VIP үстел билеті",
  "tickets.nextRelease": "Келесі сатылым:",
  "tickets.finalRelease": "Онлайн билеттердің соңғы сатылымы",
  "tickets.soldOut": "Сатылып бітті",
  "tickets.buy": "Билет алу",
  "tickets.buyGroup": "Топ билетін алу",
  "tickets.groupPerPerson": "4 × Standard билет · әр адамға {price}",
  "tickets.limitedCapacity": "Саны шектеулі",
  "tickets.reserve": "Үстел брондау",
  "tickets.vipRequired": "VIP үстел билеті қажет",
  "tickets.wantTable": "Bottle service-пен үстел брондағыңыз келе ме? VIP үстел билеті қажет.",
  "tickets.noRefund": "Билеттер қайтарылмайды · тек ұйымдастырушы іс-шараны болдырмаған жағдайда 100% қайтарылады",
  "tickets.swipe": "Көбірек көру үшін сырғыт",
  "tickets.priceProgression": "Әр сатылым біткен сайын баға көтеріледі",
  "tickets.loading": "Билеттер жүктелуде…",
  "tickets.unavailable": "Билеттер қазір қолжетімсіз",
  "perks.std1": "Барлық 3 сахнаға кіру",
  "perks.std2": "Тұру аймағы мен би алаңы",
  "perks.std3": "Барлық жалпы барлар мен rooftop-тарға кіру",
  "perks.no1": "VIP үстел аймағына кіру жоқ",
  "perks.no2": "Брондалған үстел немесе кепілдендірілген орын жоқ",
  "perks.no3": "Bottle service жоқ",
  "perks.vip1": "Тосын сыйлық ❤️‍🔥🎈 (құны 200 Kč)",
  "perks.vip2": "Seoul Floor (7-қабат) және Saigon Floor (5-қабат) VIP аймақтарына кіру.",
  "tickets.gold": "VIP Gold Table",
  "tickets.goldBadge": "Тек 3 үстел",
  "tickets.goldFee": "Үстел төлемі 3999 Kč + әр қонақ 899 Kč",
  "perks.gold1": "Сахнаға жақын үстел",
  "perks.gold2": "Барлық 3 сахнаға кіру",
  "perks.gold3": "Seoul Floor (7-қабат) және Saigon Floor (5-қабат) VIP аймақтарына кіру",
  "perks.gold4": "Басым кіру, VIP дәретхана және hostess қызметі",
  "perks.gold5": "Әр қонаққа 1 тосын сыйлық",
  "perks.gold6": "Bottle service жеке",
  "tickets.buyGold": "Gold Table сатып алу",
  "checkout.guestsGold": "Қонақтар (4–14)",
  "checkout.guestsWord": "қонақ",
  "hero.upgrade": "VIP-ке жаңарту",
  "upgrade.title": "VIP-ке жаңарту",
  "upgrade.subtitle": "Standard билетіңіз бар ма? 400 Kč-ге VIP Table билетіне айналдырыңыз.",
  "upgrade.codeLabel": "Билет кодыңыз",
  "upgrade.codePlaceholder": "ATF-XXXXXX",
  "upgrade.verify": "Билетті тексеру",
  "upgrade.found": "Билет табылды",
  "upgrade.priceLine": "Жаңарту бағасы",
  "upgrade.sameQr": "QR кодыңыз өзгермейді — төлемнен кейін VIP болып сканерленеді.",
  "upgrade.pay": "Жаңартуды төлеу",
  "upgrade.processing": "Төлем жасалуда…",
  "success.upgradeNote": "Билетіңіз енді VIP — бастапқы QR кодты пайдаланыңыз.",
  "perks.vip3": "Bottle service-пен VIP үстел брондау мүмкіндігі",
  "perks.vip4": "Брондалған үстелге hostess қызметі",
  "perks.vip5": "7-қабаттағы VIP балконға кіру",
  "perks.vip6": "Басымдықпен кіру",
  "perks.vip7": "VIP дәретхана",

  "checkout.secure": "Қауіпсіз төлем",
  "checkout.fullName": "Толық аты-жөні",
  "checkout.namePlaceholder": "Атыңыз",
  "checkout.email": "Email",
  "checkout.phone": "Телефон нөмірі",
  "checkout.quantity": "Саны",
  "checkout.ticketOne": "билет",
  "checkout.ticketMany": "билет",
  "checkout.groupNote": "1 топ = 4 билет",
  "checkout.discountCode": "Жеңілдік коды",
  "checkout.enterCode": "Кодты енгізу",
  "checkout.apply": "Қолдану",
  "checkout.codeApplied": "{code} коды қолданылды: −{percent}% (бастапқы баға {price})",
  "checkout.continueToPayment": "Төлемге өту",
  "checkout.secureNote": "Teya арқылы қауіпсіз карта төлемі, осы бетте. Билеттер тек төлем расталғаннан кейін беріледі.",
  "checkout.termsNoteA": "Жалғастыра отырып, сіз біздің",
  "checkout.termsNoteB": "Шарттар мен ережелер",
  "checkout.termsNoteC": "мен келісесіз. Билеттер қайтарылмайды және еркін беруге болады.",
  "checkout.creating": "Тапсырыс жасалуда…",
  "checkout.securePayment": "Қауіпсіз төлем",
  "checkout.groupTickets": "1 топ (4 билет)",
  "checkout.teyaNote": "Төлемдерді Teya өңдейді. QR коды бар билеттер төлем расталғаннан кейін бірден email-ге келеді.",
  "checkout.promoApplyFirst": "Төлемес бұрын жеңілдік кодын іске қосу үшін Қолдану түймесін басыңыз.",

  "success.confirming": "Төлем расталуда…",
  "success.confirmingText": "Біз төлеміңізді төлем шлюзімен тексеріп жатырмыз. Бұл бет автоматты түрде жаңарады — жаңарту қажет емес.",
  "success.slowNote": "Әдеттегіден сәл ұзақрақ — төлем әлі расталуда. Дайын болғаннан кейін билеттер осы жерде пайда болады және email-ге жібереміз. Бетті ашық қалдыра беруге болады.",
  "success.confirmed": "Төлем расталды",
  "success.youreIn": "Сіз іштесіз!",
  "success.orderLine": "Тапсырыс {order} · {tier} × {qty} · {amount} · Билеттерді скриншоттап, кіреберісте QR кодты көрсетіңіз.",
  "success.loadingTickets": "Билеттер жүктелуде…",
  "success.notCompleted": "Төлем аяқталмады",
  "success.cancelled": "Төлем болдырмалды.",
  "success.expired": "Төлем сессиясының мерзімі бітті.",
  "success.failed": "Төлем сәтсіз аяқталды.",
  "success.noCharge": "Билеттер берілмеді және сізден ақша алынбады.",
  "success.backToTickets": "Билеттерге оралу",
  "success.refunded": "Тапсырыс қайтарылды",
  "success.refundedText": "Бұл тапсырыс {how} қайтарылды.",
  "success.fully": "толық",
  "success.partially": "ішінара",
  "success.notFound": "Тапсырыс табылмады",
  "success.notFoundText": "Бұл тапсырысты таба алмадық. Жақында төледіңіз болсаңыз, сәл күтіп, қайта тексеріңіз.",
  "success.backHome": "← Басты бетке",

  "reserve.eyebrow": "VIP үстел билеті",
  "reserve.titleA": "Үстел",
  "reserve.titleB": "брондау",
  "reserve.intro": "Не қажет екенін айтыңыз — біз үстел нұсқалары мен bottle service мәліметтерімен хабарласамыз.",
  "reserve.received": "Сұраныс қабылданды",
  "reserve.receivedText": "Жақын арада VIP үстелді реттеу үшін хабарласамыз. 27.09-да DUPLEX-те кездесейік.",
  "reserve.back": "← Билеттерге оралу",
  "reserve.fullName": "Толық аты-жөні",
  "reserve.phone": "Телефон нөмірі",
  "reserve.email": "Email",
  "reserve.guests": "Қонақтар саны",
  "reserve.floor": "Қалаған қабат",
  "reserve.message": "Хабарлама (міндетті емес)",
  "reserve.messagePlaceholder": "Оқиға, бюджет, сусын тәртібі…",
  "reserve.send": "Сұраныс жіберу",
  "reserve.sending": "Жіберілуде…",

  "contact.eyebrow": "Байланыс",
  "contact.title": "Хабарласыңыз",
  "contact.email": "Email",
  "contact.instagram": "Instagram",
  "contact.venue": "Орын",
  "contact.note": "VIP үстелдер, серіктестік және баспасөз бойынша email жазыңыз — 48 сағат ішінде жауап береміз.",

  "gallery.eyebrow": "Галерея",
  "gallery.titleA": "Үй",
  "gallery.titleB": "картасы",
  "gallery.rooms": "KPOP зал • Mainstream зал • Saigon зал",
};
